import {createMuiTheme} from "@material-ui/core";
import {deepOrange, grey} from "@material-ui/core/colors";

export const drawerWidth = 240;
export const footerHeight = 80;

const palette = {
    background: {
        default: '#fff'
    },
    primary: {
        light: '#ADCEDF',
        main: '#166398',
        dark: '#19275e',
    },
    error: {
        light: '#e03333',
        main: '#d90000',
        dark: '#970000',
    },
    warning: {
        light: '#ffb74d',
        main: '#ff9800',
        dark: '#f57c00',
    },
    info: {
        light: '#2a7d8c',
        main: '#3db3c8',
        dark: '#63c2d3',
    },
    success: {
        light: '#81c784',
        main: '#4caf50',
        dark: '#388e3c',
    },
    dark: {
        text: grey[200],
        background: grey[800],
        line: grey[800],
    }
};

const ReactsTheme = createMuiTheme({
    palette,
    overrides: {
        MuiCardHeader: {
            root: {
                color: 'white',
                background: palette.primary.main,
                margin: '0'
            }
        },
        MuiContainer: {
            root: {
                'min-width': '100%',
            }
        },
        MuiChip: {
            root: {
                borderRadius: 8
            }
        }
    },
    mixins: {
        toolbar: {
            height: 56
        }
    },
});

const ChipBackgroundColors = {
    "Active": grey[200],
    "NonActive": grey[400],
    "Expired": deepOrange[800],
    "Default": grey[200],
    "Disabled": grey[400]
};

const ChipTextColors = {
    "Active": grey[800],
    "NonActive": grey[400],
    "Default": grey[800],
    "Disabled": grey[200]
}

export {ReactsTheme, palette, ChipBackgroundColors, ChipTextColors}
